import { supabase } from "~/integrations/supabase/client";

import type {
  AccountingCategory,
  AccountingCategoryFilters,
  AccountingCategoryFormData,
} from "~/types/contabilidad";

// `accounting_categories` is newer than the last generated supabase types — cast the query builder
// (same approach as fg_plant_transfers / maquila services). Route-gated to superadmin/admin.
const from = supabase.from.bind(supabase) as unknown as (table: string) => any;

const SELECT =
  "*, " +
  "income_account:income_account_id(id, code, name), " +
  "expense_account:expense_account_id(id, code, name), " +
  "inventory_account:inventory_account_id(id, code, name), " +
  "inventory_variation_account:inventory_variation_account_id(id, code, name)";

export const accountingCategoryService = {
  async getAll(
    filters?: AccountingCategoryFilters
  ): Promise<AccountingCategory[]> {
    let query = from("accounting_categories").select(SELECT);
    if (filters?.company_id) query = query.eq("company_id", filters.company_id);
    if (filters?.search) query = query.ilike("name", `%${filters.search}%`);
    const { data, error } = await query.order("name", { ascending: true });
    if (error) throw error;
    return (data ?? []) as AccountingCategory[];
  },

  async create(
    formData: AccountingCategoryFormData
  ): Promise<AccountingCategory> {
    const { data, error } = await from("accounting_categories")
      .insert(formData)
      .select(SELECT)
      .single();
    if (error) throw error;
    return data as AccountingCategory;
  },

  async update(
    id: string,
    formData: Partial<AccountingCategoryFormData>
  ): Promise<AccountingCategory> {
    const { data, error } = await from("accounting_categories")
      .update(formData)
      .eq("id", id)
      .select(SELECT)
      .single();
    if (error) throw error;
    return data as AccountingCategory;
  },

  async delete(id: string): Promise<void> {
    const { error } = await from("accounting_categories").delete().eq("id", id);
    if (error) throw error;
  },
};
